/**
 * Analytics for search.
 */

import dataLayerPush from "./dataLayerPush";

const eventCategory = "Search";

/**
 * Track input search on search pages.
 *
 * @param {string} searchType.
 * @param {string} query fo search.
 */
export function searchPerformed(searchType, query) {
  const eventLabel = `Search Type: ${searchType} | Query: ${query}`;
  const eventVars = { searchType, query };
  dataLayerPush(
    eventLabel,
    eventVars,
    "searchPerformed",
    "Performed Search",
    eventCategory
  );
}

/**
 * Track facet on search pages.
 *
 * @param {string} searchFilterCategory filing category.
 * @param {string} searchFacetChoice facet name.
 */
export function searchResultsCategoryFiltered(
  searchFilterCategory,
  searchFacetChoice
) {
  const eventLabel = `Search Filter: ${searchFilterCategory} | Choice: ${searchFacetChoice}`;
  const eventVars = {
    searchFilterCategory,
    searchFacetChoice,
  };
  dataLayerPush(
    eventLabel,
    eventVars,
    "searchResultsCategoryFiltered",
    "Filtered Search Results By Category",
    eventCategory
  );
}

/**
 * Track select on search pages.
 *
 * @param {string} searchLocationSelected value of select.
 */
export function searchLocationFiltered(searchLocationSelected) {
  const eventLabel = `Location: ${searchLocationSelected}`;
  const eventVars = {
    searchLocationSelected,
  };
  dataLayerPush(
    eventLabel,
    eventVars,
    "searchLocationFiltered",
    "Filtered Search Location",
    eventCategory
  );
}

/**
 * Track clear button on search pages.
 *
 * @param {string} searchType type of search.
 */
export function searchClearFilters(searchType) {
  const eventLabel = `Cleared Filter on: ${searchType} Search`;
  const eventVars = {
    searchType,
  };
  dataLayerPush(
    eventLabel,
    eventVars,
    "searchClearFiltersButtonEngaged",
    "Cleared Search Filters",
    eventCategory
  );
}

/**
 * Track date choose on search pages.
 *
 * @param {string} filterDateSelected type of search.
 */
export function searchDateFiltered(filterDateSelected) {
  const eventLabel = `Filter Date: ${filterDateSelected}`;
  const eventVars = {
    filterDateSelected,
  };
  dataLayerPush(
    eventLabel,
    eventVars,
    "searchDateFiltered",
    "Filtered Date of Search Results",
    eventCategory
  );
}

/**
 * Track show more btn on search pages.
 *
 * @param {string} showButtonText text of button.
 */
export function searchShowButton(showButtonText) {
  const eventLabel = `${showButtonText}`;
  const eventVars = {
    showButtonText,
  };
  dataLayerPush(
    eventLabel,
    eventVars,
    "searchShowButtonEngaged",
    "Engaged Show All or Show Less Search Results Button",
    eventCategory
  );
}

/**
 * Track sort select on search pages.
 *
 * @param {string} sortStyle text of select.
 */
export function searchResultsSorted(sortStyle) {
  const eventLabel = `Sorted by: ${sortStyle}`;
  const eventVars = {
    sortStyle,
  };
  dataLayerPush(
    eventLabel,
    eventVars,
    "searchResultsSorted",
    "Sorted Search Results List",
    eventCategory
  );
}

/**
 * Track click on result item or inside to expand button.
 *
 * @param {string} searchResultTitle text title of result item.
 * @param {string} searchResultPosition position of item.
 * @param {string} searchPageNumber.
 * @param {string} contentType.
 * @param {string} eventName.
 * @param {string} eventAction.
 */
export function searchResultItem(
  searchResultTitle,
  searchResultPosition,
  searchPageNumber,
  contentType,
  eventName,
  eventAction
) {
  const eventLabel = `Result: ${searchResultTitle} | Position: ${searchResultPosition} | Page: ${searchPageNumber} | Content Type: ${contentType}`;
  const eventVars = {
    searchResultTitle,
    searchResultPosition,
    searchPageNumber,
    contentType,
  };
  dataLayerPush(eventLabel, eventVars, eventName, eventAction, eventCategory);
}

/**
 * Track option archived events on search.
 *
 * @param {string} extraSearchOption label of checkbox.
 */
export function searchArchivedEvents(extraSearchOption) {
  const eventLabel = `Option: ${extraSearchOption}`;
  const eventVars = {
    extraSearchOption,
  };
  dataLayerPush(
    eventLabel,
    eventVars,
    "searchOptionIncludeArchivedEvents",
    "Selected Extra Search Option",
    eventCategory
  );
}

/**
 * Track tag click on search.
 *
 * @param {string} searchType type of search.
 * @param {string} tagQuery text of tag.
 */
export function searchPerformedByTag(searchType, tagQuery) {
  const eventLabel = `Search Type: ${searchType} | Query: ${tagQuery}`;
  const eventVars = {
    searchType,
    tagQuery,
  };
  dataLayerPush(
    eventLabel,
    eventVars,
    "searchPerformedByTag",
    "Performed Search by Tag",
    eventCategory
  );
}
